import { render } from "./StatisticDashboardPlus.vue?vue&type=template&id=6c8e828c&ts=true"
import script from "./StatisticDashboardPlus.vue?vue&type=script&lang=ts"
export * from "./StatisticDashboardPlus.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__